import React from "react";

// A small sub-component to handle the repeated layout
const StatItem = ({ number, label }) => (
  <div className="stat">
    <div className="stat-num">{number}</div>
    <div className="stat-label">{label}</div>
  </div>
);

const StatBar = () => {
  return (
    <div className="stat-bar">
      <StatItem number="91.1 (92%)" label="Total OPR" />
      <StatItem number="38.9 (96%)" label="Auto OPR" />
      <StatItem number="69.5 (93%)" label="Teleop OPR" />
    </div>
  );
};

export default StatBar;
